import Cookies from 'js-cookie';
import { computed, MaybeRef, onMounted, ref, unref } from 'vue';

export function useCookieBanner(options: {
  cookieDomain: MaybeRef<string>;
  siteUrl: MaybeRef<string>;
}) {
  const { cookieDomain, siteUrl } = options;

  const showBanner = ref(false);

  const cookiePolicyUrl = computed(
    () => `${unref(siteUrl)}${unref(siteUrl).endsWith('/') ? '' : '/'}cookie-policy`,
  );

  onMounted(() => {
    const cookieBanner = Cookies.get('cookie.banner');
    showBanner.value = !cookieBanner;
  });

  function onCookiesAccepted() {
    Cookies.set('cookie.banner', new Date().toISOString(), {
      domain: unref(cookieDomain),
      secure: true,
      sameSite: 'Strict',
      expires: 365,
    });
    showBanner.value = false;
  }

  return {
    showBanner,
    cookiePolicyUrl,
    onCookiesAccepted,
  };
}
